import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { getAuth, updatePassword, reauthenticateWithCredential, EmailAuthProvider } from "firebase/auth";
import Cards from "../../components/Cards";
import InputField from "../../components/InputField";
import { validationConstants } from "../../constants/validations";
import { Button } from "../../components/Buttons";
import Loading from "../../components/Loading";
import { changeCognitoPassword, getCurrentCognitoUser, getValidSession } from "../../services/auth";
import { toast } from "../../components/Toast/toast";
import { useNavigate } from "react-router-dom";

function Security() {
  const {
    getValues,
    handleSubmit,
    control,
    formState: { errors },
  }: any = useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSave = async (data: any) => {
    const { currentPassword, newPassword } = data;
    setLoading(true)
    try {
        const user = await getValidSession()
        if(user){
          const res =  await changeCognitoPassword(user, currentPassword, newPassword)
          console.log("res",res);
          if(res){
            setLoading(false)
            toast.success("Password updated successfully");
          }
        }
      
    } catch (error: any) {
      setLoading(false)
      switch (error.code) {
        case "auth/wrong-password":
          toast.error("The current password is incorrect.");
          break;
        case "auth/weak-password":
          toast.error("The new password is too weak.");
          break;
        case "auth/invalid-credential":
          toast.error("Invalid current password.");
          break;
        default:
          toast.error("Error: " + error.message);
      }
    }
  };

  if (loading) {
    return <Loading />;
  }


  return (
    <Cards variant="secondary" classname="md:p-6" childClassName="flex-col">
      <div className="border-b border-solid border-gray-300 pb-4">
        <h4>Password</h4>
        <h5 className="font-normal">Please enter your current password to change your password.</h5>
      </div>
      <form onSubmit={handleSubmit(handleSave)}>
        <div className="space-y-4">
          <div className="flex flex-col w-full md:w-[80%] lg:w-[60%] xl:w-[40%] border-b border-solid border-gray-300 py-4 gap-4">
            <InputField
              control={control}
              label="Current password"
              placeholder="Enter your current password"
              type="password"
              name="currentPassword"
              rules={{
                required: "Current password is required",
                ...validationConstants.password,
              }}
              error={errors.currentPassword}
            />
            <InputField
              control={control}
              label="New password"
              placeholder="Enter your new password"
              type="password"
              name="newPassword"
              rules={{
                required: "New password is required",
                ...validationConstants.password,
              }}
              error={errors.newPassword}
            />
            <InputField
              control={control}
              label="Confirm new password"
              placeholder="Confirm your new password"
              type="password"
              name="confirmNewPassword"
              rules={{
                required: "Confirm new password is required",
                validate: (value: string) =>
                  value === getValues("newPassword") || "Passwords do not match",
              }}
              error={errors.confirmNewPassword}
            />
          </div>
          <div className="flex flex-col sm:flex-row justify-end gap-3 w-full md:w-[80%] lg:w-[60%] xl:w-[40%]">
            <Button variant="outlined" onClick={()=>navigate("/dashboard")}>Cancel</Button>
            <Button onClick={handleSubmit(handleSave)} type="primary">
              Update Password
            </Button>
          </div>
        </div>
      </form>
    </Cards>
  );
}

export default Security;
